import { AppLayout } from 'layouts';
import { Videos } from 'features/videos';
import { useNavigateToVideoDetail, usePathToVideoDetail } from '../hooks';

const PageVideos = () => {
  const getPathToVideoDetail = usePathToVideoDetail();
  const navigateToVideoDetail = useNavigateToVideoDetail();

  return (
    <AppLayout>
      <Videos getPathToVideoDetail={getPathToVideoDetail} onNavigateToVideoDetail={navigateToVideoDetail} />
    </AppLayout>
  );
};

export default PageVideos;
